import { SegmentService } from "@main-services/segment.service";
import { CustomModal } from "../../../core/components/base-modals";
import { AfterViewInit, Directive } from "@angular/core";
import { RudderstackDynamicProperties, RudderstackService } from "@main-services/rudderstack.service";

@Directive()
export abstract class TrackingModal extends CustomModal implements AfterViewInit {
	protected abstract label: string;
	protected abstract category: string;

	protected pathPrepend: string = "";
	protected flowName: string = "";

	protected segmentService: SegmentService;
	protected rudderstackService: RudderstackService;

	protected constructor() {
		super();
		this.segmentService = CustomModal.injector.get(SegmentService);
		this.rudderstackService = CustomModal.injector.get(RudderstackService);
	}

	public close(abort: boolean = false): void {
		super.close();
	}

	protected gtmTrack(action: string): void {
		const gtmObject: Object = {
			event: "gtm.historyChange",
			"gtm.historyChangeSource": "pushState",
			"gtm.newHistoryState": this.label + "_" + action
		};
		// TODO: eslint fix
		/* eslint-disable @typescript-eslint/no-explicit-any */
		if ((<any>window).dataLayer) {
			(<any>window).dataLayer.push(gtmObject);
		}
		/* eslint-enable @typescript-eslint/no-explicit-any */
	}

	protected track(action: string): void {
		// We only need to GA-track fewer custom events (from #1474)
		switch (action) {
			case "success": {
				if (this.label === "buy" || this.label === "sell" || this.label === "swap") {
					const gaAction = this.label === "swap" ? "swap" : "normal_trade";
					this.trackGA(gaAction, { category: "trade_success" });
				}
				break;
			}
			case "pin_verified": {
				if (this.label === "deposit") {
					this.trackGA(action, { category: "fiat_deposit" });
				}
				break;
			}
			default:
				break;
		}
	}

	protected trackInitiated(): void {
		this.track("initiated");
	}

	protected trackSelect(selection: string): void {
		this.track(selection + "_select");
	}

	protected trackCancel(selection: string): void {
		this.track(selection + "_cancel");
	}

	protected trackSuccess(): void {
		this.track("success");
		this.gtmTrack("success"); // Only success is tracked by GTM
	}

	protected trackSummary(): void {
		this.track("summary");
	}

	protected rudderstackPageFlow(
		nameAppend: string,
		pathAppend: string = null,
		properties: RudderstackDynamicProperties = null
	): void {
		this.segmentService.page({
			name: `${this.flowName} ${nameAppend}`,
			overridePath: pathAppend ? `${this.pathPrepend}/${pathAppend}` : this.pathPrepend,
			properties
		});
		this.rudderstackService.page({
			name: `${this.flowName} ${nameAppend}`,
			overridePath: pathAppend ? `${this.pathPrepend}/${pathAppend}` : this.pathPrepend,
			properties
		});
	}

	protected rudderstackTrack(name: string, properties: RudderstackDynamicProperties = null): void {
		this.segmentService.track({
			name,
			properties
		});
		this.rudderstackService.track({
			name,
			properties
		});
	}

	protected rudderstackPage(name: string, path: string, properties: RudderstackDynamicProperties = null): void {
		this.segmentService.page({
			name,
			overridePath: path,
			properties
		});
		this.rudderstackService.page({
			name,
			overridePath: path,
			properties
		});
	}

	protected rudderstackFlowState(state: "successful" | "cancelled" | "started", name: string = this.flowName): void {
		this.segmentService.track({
			name,
			properties: {
				category: "Trading interaction",
				label: state
			}
		});
		this.rudderstackService.track({
			name,
			properties: {
				category: "Trading interaction",
				label: state
			}
		});
	}
}
